// extracted by mini-css-extract-plugin
export default {"container":"djKrP5yeG10xUk1YHAfk","income":"y1rXE1hoNnKs3hZjN3BZ","outgoing":"fr9CghuaJjJTHRTZzdTk","text":"MgOOAa7HUZ0FHpSrsb2O"};